import _ from 'lodash';

export const getLocalLanguage = () => {
  const language = navigator.language.split('-')[0];
  if (_.startsWith(language, 'de')) return 'de';
  if (_.startsWith(language, 'fr')) return 'fr';
  if (_.startsWith(language, 'en')) return 'en';
  if (_.startsWith(language, 'es')) return 'es';
  return 'en';
};

export const localLanguage = getLocalLanguage();
